<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.MembershipPw.msg1') }}</div>
        <div class="ft-point" style="font-size: 1.5em">{{ $t('Modal.MembershipPw.msg2') }}</div>
      </div>
      <div class="layer__body" style="min-height: 21vh">
        <div class="layer__body mg-sm" style="margin-top: 0px">
          <div class="flex-row">
            <div class="input-area">
              <label for="">{{ $t('Modal.MembershipPw.msg3') }}</label>
              <input style="font-size: 1.8em" type="text" v-if="!eyeActive" maxlength="4" :placeholder="$t('Modal.MembershipPw.msg4')" :value="reciptData" />
              <input style="font-size: 1.8em" type="text" v-if="eyeActive" maxlength="4" :placeholder="$t('Modal.MembershipPw.msg4')" :value="orgReciptData" />
              <button class="btn-eye" :class="{masking: !eyeActive}" @mouseup="eyeActive = eyeActive ? false : true"></button>
            </div>
            <div class="lyr-right" style="width: 100%; margin: 0px 20% 0em 25% !important;">
              <div class="keypad">
                <button @mouseup="setRecipt(1)">1</button>
                <button @mouseup="setRecipt(2)">2</button>
                <button @mouseup="setRecipt(3)">3</button>
                <button @mouseup="setRecipt(4)">4</button>
                <button @mouseup="setRecipt(5)">5</button>
                <button @mouseup="setRecipt(6)">6</button>
                <button @mouseup="setRecipt(7)">7</button>
                <button @mouseup="setRecipt(8)">8</button>
                <button @mouseup="setRecipt(9)">9</button>
                <button @mouseup="setRecipt(10)" class="delete">{{ $t('Modal.MembershipMaster.msg8') }}</button>
                <button @mouseup="setRecipt(0)">0</button>
                <button @mouseup="setRecipt(-1)" class="btn-back">DEL</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="layer__button">
        <button class="btn btn--cancel btn-anim" @mouseup="$emit('membersPwClose')">
          {{ $t('Modal.MembershipMaster.msg9') }}
        </button>
        <button
          class="btn btn--submit btn-anim"
          @mouseup="$emit('setMembersPw', orgReciptData)"
          :disabled="orgReciptData.length < 4"
          :class="[orgReciptData.length < 4 ? 'btn--disabled' : 'btn--color']"
        >
          {{ $t('Modal.MembershipMaster.msg6') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'membershipPwCheck',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      reciptData: '',
      orgReciptData: '',
      eyeActive: false,
    };
  },
  mounted() {},
  props: {},
  methods: {
    setRecipt(num) {
      if (num == 10) this.orgReciptData = '';
      else if (num < 0) this.orgReciptData = this.orgReciptData.slice(0, -1);
      else if (this.orgReciptData.length < 4) this.orgReciptData += num + '';

      var str = this.orgReciptData.split('');
      for (let i = 0; i < str.length; i++) {
        str[i] = '*';
      }

      this.reciptData = str.join('');
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
  unmounted() {},
};
</script>


<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/keypad.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/keypad-dark.css" scoped></style>
<style scoped>
.lyr-txt > div {
  display: inline-block !important;
}

.lyr-txt label {
  width: 29vw !important;
  height: 4.5vh !important;
  margin: 0px 0.4em 1vh !important;
}

.keypad button {
  box-shadow: rgba(0, 0, 0, 0.3) 2px 5px 10px;
}
</style>
